import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "All",
      text: `${i18n.global.t("enums.businessClassType.All")}`,
    },
    {
      value: 1,
      name: "1",
      text: `1`,
    },
    {
      value: 2,
      name: "2",
      text: `2`,
    },
    {
      value: 3,
      name: "3",
      text: `3`,
    },
    {
      value: 4,
      name: "4",
      text: `4`,
    },
    {
      value: 5,
      name: "5",
      text: `5`,
    },
    {
      value: 6,
      name: "6",
      text: `6`,
    },
    {
      value: 7,
      name: "7",
      text: `7`,
    },
    {
      value: 8,
      name: "8",
      text: `8`,
    },
    {
      value: 9,
      name: "9",
      text: `9`,
    },
    {
      value: 10,
      name: "10",
      text: `10`,
    },
  ];
}
